var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('mypage-layout', _vm._b({}, 'mypage-layout', {
    title: _vm.title
  }, false), [_c('order-list', _vm._b({
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (_ref) {
        var loading = _ref.loading;
        return [_c('purchase-status', _vm._b({}, 'purchase-status', {
          type: _vm.type,
          loading
        }, false))];
      }
    }])
  }, 'order-list', {
    type: _vm.type
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }